import { GridContainerFullHeight, Error, Grid } from '@ts/storybook';
import { useAppDispatch } from '@redux/store';
import { routerActions } from '@redux/slices/states/router/routerSlice';

const Error404 = props => {
  const dispatch = useAppDispatch();

  return (
    <GridContainerFullHeight verticalAlign="center" horizontalAlign="center">
      <Grid size={'auto'}>
        <Error
          errorCode={404}
          message={props.message ?? 'The page was not found'}
          extraFnGoHome={() => {
            dispatch(routerActions.clearHistoryRoutes());
          }}
        />
      </Grid>
    </GridContainerFullHeight>
  );
};

export default Error404;
